module.exports = __webpack_public_path__ + "img/slide-10.15b6be17.jpg";